import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
export const ClickAwayListener = ({ children, onClickAway }) => {
    const containerRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            const target = event.target;
            if (containerRef.current && !containerRef.current.contains(target)) {
                const isSelectOptionChild = target.closest('.sour-ui-select-option') || target.closest('.sour-ui-date-picker'); // Add the class name of your SelectOption element
                if (!isSelectOptionChild) {
                    onClickAway();
                }
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClickAway]);
    return (_jsx("div", { ref: containerRef, className: "contents", children: children }));
};
//# sourceMappingURL=ClickAwayListener.js.map